<script>
  import OptionInput from "./CartForm/OptionInput.svelte"

  export let selectedProduct
  export let authToken

  export let selectedHelpButton
  export let selectedSecondHelpButton
  export let selectedFallDetection
  export let selectedProtectionPlan
  export let selectedDailyCheckIn
  export let selectedCaregiverApp
  export let selectedMedicationReminders
  export let selectedLocationService
  export let selectedActivityAssurance
  export let landlineProvider
  export let selectedWristbandType
</script>

<form
  action="/dynamic_cart_line_items"
  accept-charset="UTF-8"
  method="post"
  id="cartForm"
>
  <input type="hidden" name="authenticity_token" value={authToken} />
  <OptionInput option={selectedHelpButton} />
  <OptionInput option={selectedSecondHelpButton} />
  <OptionInput option={selectedWristbandType} />
  <OptionInput option={selectedFallDetection} />
  <OptionInput option={selectedProtectionPlan} />
  <OptionInput option={selectedDailyCheckIn} />
  <OptionInput option={selectedCaregiverApp} />
  <OptionInput option={selectedMedicationReminders} />
  <OptionInput option={selectedLocationService} />
  <OptionInput option={selectedActivityAssurance} />
  <OptionInput option={landlineProvider} />
  {#if landlineProvider}
    <input
      type="hidden"
      name="landline_provider"
      id="landline_provider"
      value={landlineProvider}
    />
  {/if}
  <input
    type="hidden"
    name="product_id"
    id="product_id"
    value={selectedProduct.id}
  />
  <input type="hidden" name="quantity" id="quantity" value="1" min="1" />
</form>
